import React from 'react';

import { isTypingTarget } from '../../helpers/links_to_check_flow_helpers';
import { LINK_KEYS } from '../../helpers/links_to_check_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import Modal from '../General/Modal';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './KeysOverlay.scss';

/** The Keys button and the overlay listing every shortcut; ? opens and closes it. */
const KeysOverlay = () => {
  const { isKeysOpen, toggleKeys, closeKeys } = useLinksToCheckContext();

  useWindowKeydown(e => {
    if (e.key !== '?' || e.repeat || isTypingTarget(e.target)) return;
    e.preventDefault();
    toggleKeys();
  });

  return (
    <div className='links-to-check-keys-overlay'>
      <button type='button' className='ltc-btn ghost' onClick={toggleKeys}>
        Keys <span className='ltc-key'>?</span>
      </button>
      {isKeysOpen && (
        <Modal close={closeKeys} title='Keys'>
          <p className='keys-intro'>Keys work everywhere except while you’re typing. In search, ↑↓ and ↵ pick a result; in the form, ⌘↵ adds the product.</p>
          <div className='keys-grid'>
            {LINK_KEYS.map(row => (
              <div key={row.does} className='keys-row'>
                {row.keys.map(key => (
                  <span key={key} className='ltc-key'>
                    {key}
                  </span>
                ))}
                <span>{row.does}</span>
              </div>
            ))}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default KeysOverlay;
